import { create } from 'zustand'

/** Chrome's install offer (Android, desktop). Not in the DOM typings yet. */
export interface InstallPrompt extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

/**
 * Chrome's own install banner is held back (FR-ACC-08) and the offer kept here, for the Install
 * screen in onboarding and the Install row in Settings. It can be shown once; after that, or once
 * the app is installed, it's gone until Chrome offers again.
 */
export const useInstall = create<{ prompt: InstallPrompt | null }>(() => ({ prompt: null }))

export function watchInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    useInstall.setState({ prompt: e as InstallPrompt })
  })
  window.addEventListener('appinstalled', () => useInstall.setState({ prompt: null }))
}

/** Show the offer; true if the person installed. */
export async function promptInstall(): Promise<boolean> {
  const p = useInstall.getState().prompt
  if (!p) return false
  useInstall.setState({ prompt: null })
  await p.prompt()
  return (await p.userChoice).outcome === 'accepted'
}
